<template>
  <div>
    <div class="topLH" v-show="headerSticky">
      <div class="listHeader van-hairline--bottom">
        <div class="listHeaderSon" style="left: 16px">品种名称</div>
        <div class="listHeaderSon" style="right: 33%;">最新价</div>
        <div class="listHeaderSon" style="right: 16px">涨跌幅</div>
      </div>
    </div>
    <van-tabs style="width: 100%;height: 100%" color="#1875f8" line-width="15px" line-height="3px"
              title-active-color="#1875f8"
              offset-top="45px" duration="0.5" v-model="active" animated sticky swipeable lazy-render
              v-if="$store.state.marketMenu.data" @scroll="sticky">
      <van-tab v-for="(data,index) in $store.state.marketMenu.data[$store.state.marketTitle].categorys"
               :title="data.categoryName" :title-style="'font-size:15px;'+(active===index?'font-weight:border':'')">
        <div class="showBoy">
          <div :rendered="!resList[index]&&!$store.state.marketLock[0][index]?getSymbol(data,index):null"
               v-if="index === active">

            <van-loading vertical v-if="!resList[index]">加载中...</van-loading>
            <div v-if="resList[index]">

              <div v-for="(value,indexS) in resList[index].data.symbolInfos" class="dataBox van-hairline--bottom"
                   v-if="priceData[value.showSymbol]" @click="$goChart(value.showSymbol)">
                <lazy-component>
                  <div class="symbolMk">
                    <div class="symbolName">{{ value.showSymbol }}</div>
                    <div class="showSymbol">
                      <svg-icon :icon-class="'label'+value.symbolType" style="width: 18px;height: 12px"></svg-icon>
                      {{ value.symbolName }}
                    </div>
                  </div>
                  <div class="price">
                    <div class="priceNow">{{ priceData[value.showSymbol].strike }}</div>
                    <div class="priceTime">{{ priceTime[indexS] }}</div>
                  </div>
                  <div class="rangeMk" :style="'color:'+(priceData[value.showSymbol].profit<0?'#41bf9b':'#f84242')">
                    <div class="rateProfit">{{ priceData[value.showSymbol].rateProfit }}%</div>
                    <div class="profit">{{ priceData[value.showSymbol].profit }}</div>
                  </div>
                </lazy-component>
              </div>

            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>

</template>

<script>
export default {
  name: "within",
  data() {
    return {
      active: 0,
      menuData: {},
      resList: [],
      priceData: {},
      headerSticky: false,
    }
  },
  computed: {
    priceTime() {
      let result = []
      this.resList[this.active].data.symbolInfos.forEach(item => {
        if (!this.priceData[item.symbol]) {
          result.push(0)
        } else {
          let time = this.priceData[item.symbol].tm
          result.push(this.$format(new Date(time), "HH:mm:ss"))
        }
      })
      return result
    }
  },
  methods: {
    getSymbol(data, index) {
      this.$store.state.marketLock[0][index] = true
      this.$get(this.$store.state.marketApiUrl + '/api/symbol/findByCategory', {
        category: data.category,
        type: 1
      }).then(res => {
        this.resList[index] = res
        this.$forceUpdate()
        let symbols = []
        this.resList[index].data.symbolInfos.forEach(item => {
          symbols.push(item.symbol)
        })
        this.connectWs(symbols)
        this.getFreshPrice()
      }).catch(err => {
        console.log(err)
      })

    },
    getFreshPrice() {
      if (localStorage.newPriceKey) {
        this.priceData = JSON.parse(localStorage.newPriceKey)
        this.$forceUpdate()
      }
    },
    sticky(value) {
      this.headerSticky = value.isFixed;
    },

  },
  mounted() {
    setInterval(() => {
      this.getFreshPrice()
    }, 500)
  }
}
</script>

<style scoped>
.showBoy {
  padding-top: 68px;
}

</style>
